<template>
  <div id="instrument-operation">
    <common-search :searchList="searchList" @onSearch="onSearch" type="refund" :newKeyToName="keyToName"></common-search>

    <common-table
      :product_list="uri_list"
      :loading="loading"
      @sort-change="sortChange"
      @data-change="getMessageByPage"
      storageName="checkedHeaders_refund"
      title="万森文创退款申请表"
      type="refund"
      height="650"
      :newCheckHeader="checkedHeaders"
      :newKeyToName="keyToName"
      ></common-table>

    <div style="text-align: right;margin-top:10px">
       <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'instrument-operation',
  data() {
    return {
      loading: false,
      uri_list: null,
      searchList: {
        nickName: '', orderNo: '',
      },
      tableHandler: [],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 20,
      uploading: '',
      checkedHeaders: ['用户昵称', '用户联系方式','订单号','退款原因','退款状态' ,'照片'],
      keyToName: this.$commondata.KEY_TO_NAME_REFUND,
    }
  },
  async mounted(){
    this.getMessageByPage();
  },
  watch: {
  },
  methods: {
    async getMessageByPage(){
      this.loading = true;

      let borrowType = 'admin_now';

      let options = this.$util.formatOptions(this.searchList);

      if(this.$util.isEmpty(this.order))
        this.order = "default";

      const uri_list = await this.$request.get_message('refund',{page: this.currentPage,limit: this.pageSize,query: options});

      this.uri_list = uri_list.data;
      this.total = uri_list.total
      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },

    onSearch(){
      this.$commondata.searchObj = this.searchList;
      this.getMessageByPage();
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-operation{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/RefundReview.vue